function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  fill: "#fff",
  r: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "m.36363636 12.4549873v3.1813763h3.18137633l9.38293921-9.3829392-3.1813763-3.18137633zm15.02457994-8.66182726c.3308631-.33086314.3308631-.86533436 0-1.1961975l-1.9851788-1.98517882c-.3308632-.33086314-.8653344-.33086314-1.1961975 0l-1.5525117 1.55251164 3.1813763 3.18137633z",
  fill: "#3a993a",
  fillRule: "nonzero",
  transform: "translate(16 16)"
}));

var SvgBnEdit = function SvgBnEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBnEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bn_edit.810ff305.svg";
export { ForwardRef as ReactComponent };